<template>
	<ol>
		<li v-for="sect in obj" v-bind:key="sect.title">{{sect.title}}</li>
	</ol>
</template>

<script>
export default {
	name: 'summarySteps',
	props: {
		obj: Object
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ol {
	counter-reset: mycounter;
	margin-top: 0px;
	padding-left: 0px;
	list-style: none;
}
li {
	counter-increment: mycounter;
	display: inline-block;
	padding-right: 2em;
	font-size: 1.125em;
}
li:before {
	content: counter(mycounter);
	display: inline-block;
	margin-right: 0.5em;
	padding: 0.15em 0em;
	border: 1px solid;
	border-radius: 2em;
	background-color: #FFF;
	width: 1.5em;
	text-align: center;
}
</style>